import { motion, AnimatePresence } from "framer-motion";
import { Calendar, ArrowRight } from "lucide-react";
import { useState, useEffect } from "react";

const CALENDLY_LINK = "https://cal.com/modern-path-ai-pludn4";

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      const scrolled = window.scrollY > 300;
      setIsVisible(scrolled);

      // Hide when near bottom (footer area)
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const nearBottom = scrollTop + windowHeight > documentHeight - 400;
      setIsAtBottom(nearBottom);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && !isAtBottom && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/95 to-transparent md:hidden"
          data-testid="sticky-mobile-cta"
        >
          <a
            href={CALENDLY_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full bg-[#00FFFF] text-[#0A0A0A] py-4 px-6 rounded-lg font-bold uppercase tracking-wide shadow-[0_0_30px_rgba(0,255,255,0.4)] active:scale-95 transition-transform"
          >
            <Calendar className="w-5 h-5" />
            <span>Request a Demo</span>
            <ArrowRight className="w-5 h-5" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
